(function() {
    'use strict';

    angular
        .module('szallodak-location', ['angularjs-dropdown-multiselect', 'ui.bootstrap', 'ui.sortable', 'angularTreeview']);
})();
